import { useEffect, useState } from "react";
import { MixboardAPI } from "@/lib/mixboard/api";

interface VersionListProps {
  sessionId?: string;
  refreshToken?: number;
}

export function VersionList({ sessionId, refreshToken }: VersionListProps) {
  const [versions, setVersions] = useState<any[]>([]);

  useEffect(() => {
    if (!sessionId) return;
    MixboardAPI.listVersions(sessionId).then((res) => setVersions(res || []));
  }, [sessionId, refreshToken]);

  if (!sessionId) {
    return null;
  }

  const restore = async (versionId: string) => {
    await MixboardAPI.restoreVersion(sessionId, versionId);
  };

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-semibold text-foreground/70">Versions</h3>
      <div className="flex flex-col gap-2">
        {versions.map((version) => (
          <button
            key={version.id}
            onClick={() => restore(version.id)}
            className="bg-muted text-left px-3 py-2 rounded hover:bg-muted"
          >
            <div className="text-foreground text-sm">{version.name || "Untitled"}</div>
            <div className="text-xs text-muted-foreground">{version.created_at}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
